import { useQuery } from "react-query";
import { getSchoolBankConfig } from "../services/finance/schoolBankConfig";
import { PagedRequestType } from "../types/PagedResults";

export const useGetSchoolBankConfigQuery = (data: PagedRequestType) =>
  useQuery(
    ["schoolbankconfigs-pagination", JSON.stringify(data)],
    () => getSchoolBankConfig(data)
  );